<template>
<div class="chapter">
<div class="inner_page">
<p class="epi">What the woman who labors wants is the right to live, not simply exist—the right to life as the rich woman has the right to life, and the sun and music and art. You have nothing that the humblest worker has not a right to have also. The worker must have bread, but she must have roses, too. Help, you women of privilege, give her the ballot to fight with.</p>
<p class="right"><em>—Rose Schneiderman, at the 1912 Lawrence textile strike</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?58cf3a0b